import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { ILightZone } from '../../../../../types/Lights/lightZoneInterfaces';
import Strings from '../../../../../i18n';
import { SideBarDeleteActionWithPopup } from '../../../../../components/commons/SideBarComponents/DeleteActionWithPopup/sideBarDeleteActionWithPopup';
import { useDeleteZonesMutation } from '../../../../../services/lightsZones/lightsZonesService';

interface IMultiDetailsLighZoneProps {
  lightZones: ILightZone[];
  reloadTable: () => void;
  closeSideBar: () => void;
}
export const MultiDetailsLightZone = ({
  lightZones,
  reloadTable,
  closeSideBar
}: IMultiDetailsLighZoneProps) => {
  const allLightsAreZone =
    lightZones.length && lightZones.every((zone) => zone.isZone);
  const [deleteZone, { isSuccess }] = useDeleteZonesMutation();

  useEffect(() => {
    if (isSuccess) {
      toast.success(Strings.lightsZones.deleteZonesSuccessfully);
      reloadTable();
      closeSideBar();
    }
  }, [isSuccess]);

  return (
    <StyledContainerItems>
      <StyledTitleSideBar> {Strings.lightsZones.title}</StyledTitleSideBar>
      {allLightsAreZone && (
        <SideBarDeleteActionWithPopup
          textIcon={Strings.lightsZones.deleteZones}
          onDelete={() => deleteZone({ id: lightZones.map((zone) => zone.id) })}
          titleConfirmation={Strings.lightsZones.deleteZones}
          textConfirmation={Strings.lightsZones.confirmDelete}
        />
      )}
    </StyledContainerItems>
  );
};
